import ArchiveAgencyBillingStatus from "./ArchiveAgencyBillingStatus.js";
import BoardingAgencyBillingStatus from "./BoardingAgencyBillingStatus.js";
import ModelFactory from "../ModelFactory.js";
import PayingAgencyBillingStatus from "./PayingAgencyBillingStatus.js";
import UnspecifiedAgencyBillingStatus from "./UnspecifiedAgencyBillingStatus.js";

/**
 * TODO: write documentation
 */
class AgencyBillingStatusFactory extends ModelFactory {
	allClasses() {
		return [
			ArchiveAgencyBillingStatus,
			BoardingAgencyBillingStatus,
			PayingAgencyBillingStatus,
			UnspecifiedAgencyBillingStatus,
		];
	}

	allInstances() {
		return this.allClasses().map((klass) => klass.instance());
	}

	_getTypeFromJson(json) {
		return json || "Unspecified";
	}

	_instantiate(klass, _json, _context) {
		return klass.instance();
	}
}

const agencyBillingStatusFactory = new AgencyBillingStatusFactory();

export default agencyBillingStatusFactory;
